import { render } from "./Embroidery.vue?vue&type=template&id=33044229"
import script from "./Embroidery.vue?vue&type=script&lang=js"
export * from "./Embroidery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__